import { useMemo } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router';

const nonAreaLegacyRoots = new Set(['members', 'messages', 'settings']);

function LegacyRedirect() {
    const [searchParams] = useSearchParams();
    const { pathname } = useLocation();
    const propertyAssociationId = searchParams.get('propertyAssociationId');
    const propertyAssociationAreaId = searchParams.get('propertyAssociationAreaId');
    const sanitizedSearchParams = useMemo(() => {
        const params = new URLSearchParams(searchParams);
        params.delete('propertyAssociationId');
        params.delete('propertyAssociationAreaId');
        return params;
    }, [searchParams]);

    // Determine return path based on the legacy route
    const getReturnPath = (): string => {
        if (pathname === '/bookings/') {
            const bookingId = sanitizedSearchParams.get('bookingId');
            return bookingId ? `/bookings?bookingId=${bookingId}` : '/bookings';
        }

        // For other legacy routes, preserve the path with search params
        const query = sanitizedSearchParams.toString();
        return query ? `${pathname}?${query}` : pathname;
    };

    const returnPath = getReturnPath();
    const navigationState = useMemo(() => ({ returnPath }), [returnPath]);
    const normalizedReturnPath = returnPath.startsWith('/') ? returnPath : `/${returnPath}`;
    const legacyRoot = pathname.split('/').filter(Boolean)[0]?.toLowerCase();

    if (propertyAssociationId) {
        if (legacyRoot && nonAreaLegacyRoots.has(legacyRoot)) {
            return <Navigate to={`/${propertyAssociationId}${normalizedReturnPath}`} replace />;
        }

        if (propertyAssociationAreaId) {
            return <Navigate to={`/${propertyAssociationId}/areas/${propertyAssociationAreaId}${normalizedReturnPath}`} replace />;
        }

        return <Navigate to={`/${propertyAssociationId}/areas`} replace state={navigationState} />;
    }

    return <Navigate to="/" replace state={navigationState} />;
}

export default LegacyRedirect;
